export const loadMunMoiFlutter = () => {
	loadFirebase().then(function () {
		const mainScript = document.createElement('script');
		mainScript.src = 'main.dart.js';
		document.body.appendChild(mainScript);
	});
};

const loadFirebase = () => {
	return new Promise((resolve, reject) => {
		Promise.all([
			loadScript('https://www.gstatic.com/firebasejs/7.14.3/firebase-app.js'),
			loadScript('https://www.gstatic.com/firebasejs/7.14.3/firebase-analytics.js'),
			loadScript('https://www.gstatic.com/firebasejs/7.14.3/firebase-auth.js')
		]).then(function () {
			var firebaseConfig = {
				apiKey: 'AIzaSyDiySG0uBY5-MDE-U38HvRQ4o_ME7p5tHE',
				authDomain: 'mun-moi.firebaseapp.com',
				databaseURL: 'https://mun-moi.firebaseio.com',
				projectId: 'mun-moi',
				storageBucket: 'mun-moi.appspot.com',
				messagingSenderId: '280389144668',
				appId: '1:280389144668:web:9a055961310e3457ff5699',
				measurementId: 'G-7C9W0RP0D3'
			};

			// eslint-disable-next-line no-undef
			firebase.initializeApp(firebaseConfig);
			// eslint-disable-next-line no-undef
			firebase.analytics();
			resolve();
		});
	});
};

const loadScript = (src) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = src;
		script.addEventListener('load', function () {
			resolve(script);
		});
		document.head.appendChild(script);
	});
};
